"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reselect = require("reselect");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _usePrevious = _interopRequireDefault(require("../../hooks/usePrevious"));

var _reducers = require("../../reducers");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var getAnnotationData = function getAnnotationData(state) {
  var reduxContext = state["".concat(_constants.PREFIX, ":context")];
  var reduxComments = state["".concat(_constants.PREFIX, ":comments")].comments;
  var reduxDelta = state["".concat(_constants.PREFIX, ":delta")];
  var result = {
    color: reduxContext.annotationColor,
    currentlyPlacing: reduxContext.isPlacingAnnotation,
    imageCoordinatesInfo: reduxContext.imageCoordinatesInfo,
    location: reduxContext.annotationLocation,
    type: reduxContext.newAnnotationType,
    annotatingItmId: reduxContext.annotatingItmId,
    lastRequestAssetId: reduxDelta.lastRequestAssetId
  };
  var newAndEditedComments = reduxComments.filter(function (comment) {
    return comment.recentActivity === _constants.JUST_ADDED || comment.recentActivity === _constants.JUST_EDITED;
  });

  if (newAndEditedComments.length) {
    var comment = newAndEditedComments[0];
    var newOrEditedCommentData = {
      id: comment.id,
      type: comment.recentActivity
    };

    if (comment.recentActivity === _constants.JUST_EDITED && comment.target.selector.subtype === 'note') {
      newOrEditedCommentData.coordinates = {
        x: comment.target.selector.noteX,
        y: comment.target.selector.noteY
      };
    }

    result.newOrEditedCommentData = newOrEditedCommentData;
  }

  return result;
};

var annotationDataSelector = (0, _reselect.createSelector)(getAnnotationData, function (annotationData) {
  return annotationData;
});

var useAnnotatingChange = function useAnnotatingChange() {
  var onAnnotatingChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  var _useContext = (0, _react.useContext)(_AppContext.default),
      annotationsEnabled = _useContext.annotationsEnabled,
      assetData = _useContext.assetData;

  var currentDependencies = (0, _reducers.useSelector)(annotationDataSelector);
  var previousDependencies = (0, _usePrevious.default)(currentDependencies) || {};
  (0, _react.useEffect)(function () {
    var assetId = assetData === null || assetData === void 0 ? void 0 : assetData.id;

    if (annotationsEnabled && !(0, _lodash.default)(currentDependencies, previousDependencies)) {
      var color = currentDependencies.color,
          currentlyPlacing = currentDependencies.currentlyPlacing,
          imageCoordinatesInfo = currentDependencies.imageCoordinatesInfo,
          location = currentDependencies.location,
          newOrEditedCommentData = currentDependencies.newOrEditedCommentData,
          type = currentDependencies.type,
          annotatingItmId = currentDependencies.annotatingItmId,
          lastRequestAssetId = currentDependencies.lastRequestAssetId;
      var prevColor = previousDependencies.color,
          prevCurrentlyPlacing = previousDependencies.currentlyPlacing,
          prevLocation = previousDependencies.location;
      var payload = {};

      if (currentlyPlacing && !prevCurrentlyPlacing) {
        payload = {
          color: color,
          type: type,
          trigger: 'start'
        };

        if (annotatingItmId === 'root') {
          payload.action = 'new';
        } else {
          payload.id = annotatingItmId;
          payload.action = 'edit';
        }
      } else if (newOrEditedCommentData && prevLocation && (newOrEditedCommentData.type !== _constants.JUST_EDITED || (0, _lodash.default)(newOrEditedCommentData.coordinates, {
        x: prevLocation.coordinates.noteX,
        y: prevLocation.coordinates.noteY
      }))) {
        payload = {
          action: newOrEditedCommentData.type === _constants.JUST_EDITED ? 'edit' : 'new',
          trigger: 'submit'
        };
        assetId = lastRequestAssetId;
      } else if (!currentlyPlacing && prevCurrentlyPlacing && !location || !location && prevLocation) {
        payload = {
          trigger: 'cancel'
        };
      } else if (location && !prevLocation) {
        payload = {
          color: color,
          location: location,
          trigger: 'place',
          type: type
        };

        if (imageCoordinatesInfo) {
          payload.coordinateData = imageCoordinatesInfo;
        }
      } else if (type && (color !== prevColor || (type === 'pin' || type === 'draw') && !(0, _lodash.default)(location, prevLocation))) {
        payload = {
          color: color,
          location: location,
          trigger: 'update',
          type: type
        };
      }

      if (payload.trigger) {
        onAnnotatingChange(payload, {
          assetId: assetId
        });
      }
    }
  });
};

var _default = useAnnotatingChange;
exports.default = _default;